// asset imports
import "@/assets/scss/soft-ui-dashboard.scss";
import "@/components/base/Crud/CrudBase.css";
import "@/assets/css/font-size-preference.css";

export default {};
